import urlConfig from "../../config.json";
import { BACKEND_URL } from "../../constants";
import { axios } from "../../utils/axiosConfig";

export const createTask = async (payload) => {
  const ROUTE = urlConfig.backend.routes.tasks.createTask;
  const url = `${BACKEND_URL}${ROUTE}`;

  return await axios
    .post(url, payload)
    .then((res) => {
      if (res.status === 200) {
        return { res: res.data, error_code: 1 };
      }
      return {
        error_code: 2,
        error_message: "Something went wrong. Please try again later.",
      };
    })
    .catch((error) => {
      const status = error.response?.status;
      const data = error.response?.data;
      if (status === 422 || status === 400) {
        const msg =
          typeof data?.message === "string"
            ? data.message
            : Array.isArray(data?.errors)
              ? data.errors.join(", ")
              : "Request could not be completed.";
        return {
          error_code: 3,
          error_message: msg,
          errors: data?.errors,
        };
      }
      return {
        error_code: 3,
        error_message:
          typeof data?.message === "string"
            ? data.message
            : error.message || "Request failed",
      };
    });
};
